import { Injectable } from '@angular/core';

import { ConfigParserService } from '../../shared/services/config-parser.service';

export interface FirstRunCalloutsConfig {
    hideInTestMode: boolean;
    version: number;
    dragAndDropCalloutEnabled: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class FirstRunCalloutsConfigService {
    public readonly config: FirstRunCalloutsConfig;

    constructor(configParserService: ConfigParserService) {
        this.config = configParserService.parse<FirstRunCalloutsConfig>('firstRunCalloutsConfig') || {
            hideInTestMode: true,
            version: 0,
            dragAndDropCalloutEnabled: false
        };
    }
}
